import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	genericHeader: {
		id: 'servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-header',
		defaultMessage: 'Something went wrong',
		description: 'Error header shown when an article list could not be loaded.',
	},
	genericMessage: {
		id: 'servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-message',
		defaultMessage: "We couldn't load the articles. Please refresh and try again.",
		description: 'Error message shown when an article list could not be loaded.',
	},
});
